import { AspectRatio, Button, Stack, Typography } from "@mui/joy";
import { theme } from "../../../components/Theme";
import { useTranslation } from "react-i18next";

type Props = {
  onClick: (businessAccountType: string) => void;
  currentAccountType: string;
};

const AccountTypeSelection = ({ onClick, currentAccountType }: Props) => {
  const { t } = useTranslation();

  const accountTypes = [
    {
      value: "SELLER",
      title: t("landing.signup.selectAccountType.seller.title"),
      prompt: t("landing.signup.selectAccountType.seller.prompt"),
      icon: "/seller-account.png",
      iconSelected: "/seller-account-selected.png",
    },
    {
      value: "BUYER",
      title: t("landing.signup.selectAccountType.buyer.title"),
      prompt: t("landing.signup.selectAccountType.buyer.prompt"),
      icon: "/buyer-account.png",
      iconSelected: "/buyer-account-selected.png",
    },
  ];

  return (
    <Stack direction={"column"} gap={"16px"}>
      <Typography
        level="text-md-semibold"
        textColor={theme.palette.common.black}
      >
        {t("landing.signup.selectAccountType.prompt")}
      </Typography>

      <Stack direction={"row"} gap={{ xs: "8px", md: "16px" }}>
        {/* seller */}
        <Button
          variant="linkz-role-selection"
          key={accountTypes[0].title}
          onClick={() => {
            onClick(accountTypes[0].value);
          }}
          sx={{
            minWidth: `48%`,
            textAlign: "left",
            justifyContent: "flex-start",
            position: "relative",
            overflow: "hidden",
            height: "82px",
            px: { xs: "12px", md: "16px" },
            py: { xs: "12px", md: "10px" },
            backgroundColor:
              currentAccountType === accountTypes[0].value
                ? theme.palette.primary[50]
                : theme.palette.common.white,
            borderColor:
              currentAccountType === accountTypes[0].value
                ? theme.palette.primary[500]
                : theme.vars.palette.neutral[400],
          }}
        >
          <Stack direction={"column"} gap={0}>
            <Typography level={"text-lg-bold"}>
              {accountTypes[0].title}
            </Typography>

            <Typography level={"text-sm-medium"}>
              {accountTypes[0].prompt}
            </Typography>
          </Stack>

          {/* icon image */}
          <AspectRatio
            ratio={1}
            variant="plain"
            sx={{
              width: { xs: "43px", md: "64px" },
              height: { xs: "43px", md: "64px" },
              position: "absolute",
              bottom: 0,
              right: { xs: "-6px", md: "-1px" },
            }}
          >
            <img
              src={
                currentAccountType === accountTypes[0].value
                  ? accountTypes[0].iconSelected
                  : accountTypes[0].icon
              }
              alt={accountTypes[0].title}
            />
          </AspectRatio>
        </Button>

        {/* buyer */}
        <Button
          variant="linkz-role-selection"
          key={accountTypes[1].title}
          onClick={() => {
            onClick(accountTypes[1].value);
          }}
          sx={{
            minWidth: `48%`,
            textAlign: "left",
            justifyContent: "flex-start",
            position: "relative",
            overflow: "hidden",
            height: "82px",
            backgroundColor:
              currentAccountType === accountTypes[1].value
                ? theme.palette.primary[50]
                : theme.palette.common.white,
            borderColor:
              currentAccountType === accountTypes[1].value
                ? theme.palette.primary[500]
                : theme.vars.palette.neutral[400],
          }}
        >
          <Stack direction={"column"} gap={0}>
            <Typography level={"text-lg-bold"}>
              {accountTypes[1].title}
            </Typography>

            <Typography level={"text-sm-medium"}>
              {accountTypes[1].prompt}
            </Typography>
          </Stack>

          {/* icon image */}
          <AspectRatio
            ratio={1}
            variant="plain"
            sx={{
              width: { xs: "43px", md: "64px" },
              height: { xs: "43px", md: "64px" },
              position: "absolute",
              bottom: 0,
              right: { xs: "6px", md: "24px" },
            }}
          >
            <img
              src={
                currentAccountType === accountTypes[1].value
                  ? accountTypes[1].iconSelected
                  : accountTypes[1].icon
              }
              alt={accountTypes[1].title}
            />
          </AspectRatio>
        </Button>
      </Stack>
    </Stack>
  );
};

export default AccountTypeSelection;
